import { render, staticRenderFns } from "./health-record.vue?vue&type=template&id=c7a0734e&scoped=true"
import script from "./health-record.vue?vue&type=script&lang=js"
export * from "./health-record.vue?vue&type=script&lang=js"
import style0 from "./health-record.vue?vue&type=style&index=0&id=c7a0734e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a0734e",
  null
  
)

export default component.exports